import React, { useEffect, useRef } from 'react';
import CanvasEngine from '../canvas/CanvasEngine';

const CanvasBoard = () => {
  const canvasRef = useRef(null);
  const engineRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      engineRef.current = new CanvasEngine(canvas);
      window.canvasEngine = engineRef.current;
    }
  }, []);
  

  return (
    
    <div style={{ width: '100%', height: '94vh', background: 'black' }}>
      <canvas
        ref={canvasRef}
        style={{
          backgroundColor: '#111',
          width: '100%',
          height: '100%',
          display: 'block',
          cursor: 'grab',
        }}
      />
       </div>
   
  );
};

export default CanvasBoard;


// import React, { useEffect, useRef } from "react";
// import CanvasEngine from "../canvas/CanvasEngine";
// import { useCommentData } from "./ReportBugandImprovement/CommentDataContext";

// const CanvasBoard = () => {
//   const canvasRef = useRef(null);
//   const engineRef = useRef(null);
//   const {
//     isDotMode,
//     setisDotMode,
//     drawDotEventHandler,
//     selectedQuery,
//     rectangleMode,
//     seeAllDots,
//     activeTab,
//     addRectangleToComment,
//     commentDetails,
//   } = useCommentData();

//   // Determine the active tab color
//   let color = "";
//   if (activeTab === "bug") color = "red";
//   else if (activeTab === "improvement") color = "blue";
//   else if (activeTab === "query") color = "green";

//   // Initialize CanvasEngine once
//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (canvas && !engineRef.current) {
//       engineRef.current = new CanvasEngine(canvas);
//       window.canvasEngine = engineRef.current;
//     }
//   }, []);

//   // Update engine data and redraw on state change
//   useEffect(() => {
//     if (!engineRef.current) return;
//     engineRef.current.setData({
//       commentDetails,
//       activeTab,
//       selectedQuery,
//       seeAllDots,
//       color,
//       isDotMode,
//       rectangleMode,
//     });
//     engineRef.current.draw();
//   }, [
//     commentDetails,
//     activeTab,
//     selectedQuery,
//     seeAllDots,
//     color,
//     isDotMode,
//     rectangleMode,
//   ]);

//   // Dot mode click handling
//   useEffect(() => {
//     if (!engineRef.current) return;

//     if (!isDotMode) {
//       return engineRef.current.setCanvasClickHandler(null);
//     }

//     engineRef.current.setCanvasClickHandler((x, y, e) => {
//       drawDotEventHandler(x, y);
//       setisDotMode(false);
//     });
//   }, [isDotMode]);

//   // Rectangle mode drag handling
//   useEffect(() => {
//     if (!engineRef.current) return;
//     if (!rectangleMode) {
//       return engineRef.current.setCanvasRectangleClickHandler(null);
//     }
//     if (selectedQuery == null) return;

//     engineRef.current.setCanvasRectangleClickHandler((bbox) => {
//       addRectangleToComment(bbox);
//     });
//   }, [rectangleMode]);

//   return (
//     <div className="w-full h-[94vh] bg-black relative">
//       <canvas
//         ref={canvasRef}
//         className={`bg-[#111] w-full h-full block ${
//           isDotMode || rectangleMode ? "cursor-crosshair" : "cursor-grab"
//         }`}
//       />
//     </div>
//   );
// };

// export default CanvasBoard;

